import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './store';
import { ApolloProviderWrapper } from './services/apollo/provider';
import { ThemeProvider } from './context/ThemeContext';
import { Router } from './router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import './styles/global.css';

// Import i18n instance and provider
import './i18n/config';
import I18nProvider from './i18n/I18nProvider';

// Initialize the application
const initApp = () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Root element not found');
  
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <I18nProvider>
        <Provider store={store}>
          <ApolloProviderWrapper>
            <ThemeProvider>
              <Router />
              <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
            </ThemeProvider>
          </ApolloProviderWrapper>
        </Provider>
      </I18nProvider>
    </React.StrictMode>
  );
};

// Start the application
initApp();